import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { HydraAddShipToOptionsData } from './hydraAddShipToOption'
import type { HydraErrorType } from '../_hydraError'

type HydraUpdateShipToOptionsResponse = {
  alias: string
  isDefaultOption: boolean
  shipToAddress: {
    address1: string
    address2: string
    city: string
    country: Alpha2CountryCode
    state: string
    zip: string
  }
  shipToName: {
    firstName: string
    lastName: string
  }
  shipToOptionId: {
    unicity: number
  }
  href: string
}

export type HydraUpdateShipToOptionsProps = {
  customerUrl: string
  optionUrl: string
  hydraToken: string
  data: HydraAddShipToOptionsData
}

export const hydraUpdateShipToOption = ({
  customerUrl,
  optionUrl,
  hydraToken,
  data,
}: HydraUpdateShipToOptionsProps) => {
  const parts = optionUrl.split('/')

  const request: SendRequestType = {
    method: 'POST',
    baseURL: 'internal',
    url: `${customerUrl}/shipToOptions/${parts.at(-1)}`,
    withAuth: true,
    token: hydraToken,
    data,
  }

  return httpTools.sendRequest<
    HydraUpdateShipToOptionsResponse & HydraErrorType
  >(request)
}
